import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MapLoader } from './map-loader.service';

export const mapResolver: ResolveFn<unknown> = () =>
  inject(MapLoader).importLibrary('maps');
